module.exports = __webpack_public_path__ + "static/media/strawberry-festival.8b7de47a.png";